module.exports = __webpack_public_path__ + "img/remi.9fb37ef3.jpg";